export default "__VITE_ASSET__CwCetPwm__"